export default "__VITE_ASSET__Djzgfssm__"